import { Link } from '@exam-management/router';
import { Alert, Text, Flex, OpenInNewOutlinedIcon } from '@shared/components';

import { type GenerateQSetErrorCode } from '../../types';

import { ERROR_CODE_TO_MESSAGE } from './constants';

interface GenerateQSetErrorAlertProps {
  examCourseId: string;
  qConfigId: string;
  errorCode?: GenerateQSetErrorCode | null;
}

export default function GenerateQSetErrorAlert(
  generateQSetErrorAlertProps: Readonly<GenerateQSetErrorAlertProps>,
) {
  const { errorCode, examCourseId, qConfigId } = generateQSetErrorAlertProps;

  if (!errorCode) {
    return null;
  }

  return (
    <Alert sx={{ alignItems: 'flex-start' }} severity='error'>
      <Flex
        sx={(theme) => ({
          flexDirection: 'column',
          gap: theme.spacing(1),
          'a:hover, a:visited': {
            textDecorationColor: theme.palette.error.darker,
          },
        })}
      >
        <Text variant='body1Semibold'>ไม่สามารถ Generate QSet จาก QConfig นี้ได้</Text>
        <Text variant='body2'>{ERROR_CODE_TO_MESSAGE[errorCode]}</Text>
        {errorCode === 'DISABLED_LEARNING_OBJECTIVE_STATEMENTS_FOUND' ? (
          <Link
            to='/exam-courses/:courseId/qconfigs/:qconfigId/details'
            params={{ courseId: examCourseId, qconfigId: qConfigId }}
            target='_blank'
            rel='noopener noreferrer'
          >
            <Flex
              sx={(theme) => ({
                alignItems: 'center',
                color: theme.palette.error.darker,
                gap: theme.spacing(0.5),
              })}
            >
              <Text variant='body2' sx={{ textDecoration: 'none' }}>
                ไปตรวจสอบและจัดการที่ QConfig
              </Text>
              <OpenInNewOutlinedIcon sx={{ fontSize: '20px' }} />
            </Flex>
          </Link>
        ) : null}
      </Flex>
    </Alert>
  );
}
